import {slideToggle} from './slideToggle';


document.addEventListener("DOMContentLoaded", function () {
	const accordionNavs = document.querySelectorAll('.accordion-nav');
	if (accordionNavs) {
		Object.entries(accordionNavs).map(([i, e]) => {
			const heading = e.querySelector('.accordion-nav__heading');
			const headingLink = heading.querySelector('a');
			const list = e.querySelector('.accordion-nav__list');
			heading.addEventListener("click", (e) => {
				if (window.innerWidth < 768 && headingLink.getAttribute('href') === '#') {
					e.preventDefault();
					heading.classList.toggle('open');
					slideToggle(list, 500);
				}
			});

		});
	}
});







